import { Col, Divider, Row } from "antd";
import "./footer.less";
import Btelegram from "src/shared/assets/images/landing/telegram.png";
import youtubeImg from "src/shared/assets/images/landing/youtube.png";
import aparatImg from "src/shared/assets/images/landing/aparat.png";
import telegram from "src/shared/assets/images/landing/bi_telegram.png";
import { ButtonC } from "src/shared/components";
import useDomain from "src/shared/hooks/useDomain";
import fileDownloader from "src/shared/function/fileDownloader";

const LFooter = () => {
  const { name, supportPhone, logoPath, telegramChannel, youtube, aparat } =
    useDomain();

  return (
    <section id="footer">
      <Row justify="center" gutter={[0, 30]}>
        <Col xs={22} md={22} lg={21}>
          <img src={fileDownloader(logoPath)} className="logo" />
        </Col>
        <Col xs={22} md={22} lg={21}>
          <Row justify="space-between" gutter={[10, 25]}>
            <Col xs={24} md={12} lg={8} xl={5}>
              <h4>خدمات اینستاگرام</h4>
              <p> خرید فالوور ایرانی</p>
              <p>خرید لابک ایرانی</p>
              <p>خرید بازدید (ویو ایرانی)</p>
              <p>خرید کامنت ایرانی</p>
              <p>خرید بازدید لایو</p>
              <p>خرید بازدید استوری</p>
            </Col>
            <Col xs={24} md={12} lg={8} xl={5}>
              <h4>خدمات تکمیلی اینستاگرام</h4>
              <p>خرید لایک و ویو خودکار</p>
              <p>خرید کامنت خودکار</p>
              <p>خرید ریچ و ایمپرشن(اسپلور)</p>
              <p>خرید سیو اینستاگرام</p>
            </Col>
            <Col xs={24} md={12} lg={8} xl={5}>
              <h4>سایر شبکه های اجتماعی</h4>
              <p>خرید واچ تایم یوتیوب</p>
              <p>خرید بازدید یوتیوب</p>
              <p>خرید ریتونت</p>
              <p>خرید فالوور توییتر</p>
              <p>خرید لایک توییتر</p>
            </Col>
            <Col xs={24} md={12} lg={8} xl={9} className="social-col">
              {telegramChannel && (
                <div className="telegram">
                  <h4>{name} را در تلگرام دنبال کنید:</h4>
                  <ButtonC
                    className="btn-telegram"
                    href={`https://t.me/${telegramChannel}`}
                    target="_blank"
                  >
                    <span>
                      <img src={Btelegram} />
                      کانال تلگرام {name}
                    </span>
                  </ButtonC>
                </div>
              )}
              <div className="other-social">
                <h4>{name} در شبکه های اجتماعی:</h4>
                <div className="icons">
                  {youtube && (
                    <a
                      href={`https://www.youtube.com/channel/${youtube}`}
                      target="_blank"
                    >
                      <img src={youtubeImg} />
                    </a>
                  )}
                  {youtube && (
                    <a
                      href={`https://www.aparat.com/${youtube}`}
                      target="_blank"
                    >
                      <img src={aparatImg} className="aparat" />
                    </a>
                  )}
                  {telegramChannel && (
                    <a href={`https://t.me/${telegramChannel}`} target="_blank">
                      <img src={telegram} />
                    </a>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={22} md={22} lg={21} style={{ marginBottom: "24px" }}>
          <Divider style={{ margin: 0 }} />
        </Col>
        <Col xs={22} md={22} lg={21}>
          <Row className="footer-bottom">
            <Col xs={24} md={12} lg={12} xl={5}>
              <p>شیوه پرداخت</p>
              <p>شرایط استفاده</p>
              <p>درباره ما</p>
            </Col>
            <Col xs={24} md={12} lg={12} xl={5}>
              <p>پاسخ به پرسش های متداول</p>
              <p>
                <a href="https://my.zaamin.ir/panel" target="_blank">
                  درخواست نمایندگی (وایت لیبل)
                </a>
              </p>
              <p>
                <a href="https://my.99panel.com/panel" target="_blank">
                  Api
                </a>
              </p>
            </Col>
            <Col xs={24} md={12} lg={12} xl={14}></Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default LFooter;
